import React, { Component } from 'react';
import DrawerCustom from '../../components/DrawerCustom';
import ButtonCustom from '../../components/ButtonCustom';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Typo from '../../components/CustomTypo';
import { Grid, IconButton, Badge, Button } from '@material-ui/core';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import CustomizedCircularProgress from '../../components/CircularProgress'
import CircularProgress from '@material-ui/core/CircularProgress';
import Loading from '../../components/Loading';
import { CartItemIcon } from '../../components/icons';
import {ScrollMenu} from 'react-horizontal-scrolling-menu';
import "./App.css"
import {domainName, portal_config} from '../../../portal.config'
import { getAppCfg, getLogo } from '../../utils/common';
import classNames from 'classnames';
import { getOrderCache, order_key } from '../../utils/order_cache';
const styles = theme => ({
    '@global': {
        "*::-webkit-scrollbar": {
            width: theme.spacing(1),
            height: theme.spacing(1.5),
        },
        "*::-webkit-scrollbar-thumb": {
            background: theme.palette.background.onCard,
        },
        "*::-webkit-scrollbar-track": {
            background: theme.palette.background.primary
        },
    },
    container: {
        padding: theme.spacing(6, 4, 5, 4)
    },
    row: {
        margin: theme.spacing(2, 0, 2, 0)
    },
    menu: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
    },
    menuItem: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    item_image: {
        marginTop: theme.spacing(2),
        width: '100%',
        height: 100,
        objectFit: 'contain',
    },
    item_image_logo: {
        marginTop: theme.spacing(4),
        width: '100%',
        height: 60,
        objectFit: 'contain',
    },
    itemContainer: {
        padding: theme.spacing(2),
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1),
        },
        
    },
    item_disable:{
        opacity: 0.4,
        textDecoration: 'line-through',
        cursor: 'default'
    },
    itemContent: {
        borderRadius: theme.shape.borderRadius2x,
        backgroundColor: theme.palette.background.secondary,
        // height: 230
    },
    itemHeader: {
        height: 100
    },
    itemFooter: {
        // height: 100,
        padding: theme.spacing(3, 3, 0, 3),
        overflow: "hidden"
    },
    itemName: {
        height: 34,
    },
    wraptext: {
        lineHeight:'1.25em',
        // height:'2em',
        overflow: "hidden",
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical'
    },
    itemDesc: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        // height: 33,
        // borderBottomLeftRadius: theme.shape.borderRadius2x,
        // borderBottomRightRadius: theme.shape.borderRadius2x,
    },
    itemPrice: {
        height: 33,
        backgroundColor: theme.palette.background.secondary,
        marginTop: theme.spacing(2)
    },
    iconBtnRoot: {
        ...theme.palette.button.primary,
        height: 44,
        width: 44
    },
    badgeColorPrimary: {
        ...theme.palette.button.light,
        top: -theme.spacing(2)
    },
    underline: {
        textDecoration: 'underline',
        cursor: 'pointer'
    },
    filter_item: {
        padding: theme.spacing(2, 4, 2, 4),
        margin: theme.spacing(1, 2, 1, 2),
        border: '1px solid',
        borderRadius: theme.shape.borderRadius5x,
        ...theme.palette.button.info,
        cursor: 'pointer',
        minWidth: 60,
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        touchAction: "manipulation",
        'white-space': 'nowrap',
        '&:active': {
            ...theme.palette.button.info,
            border: 'none',
            outline: 'none'
        },
        '&:hover': {
            ...theme.palette.button.info,
        },
        '&:focus': {
            ...theme.palette.button.info,
            border: 'none',
            outline: 'none'
        }
    },
    filter_item_selected: {
        padding: theme.spacing(2, 4, 2, 4),
        margin: theme.spacing(1, 2, 1, 2),
        border: '1px solid',
        borderRadius: theme.shape.borderRadius5x,
        ...theme.palette.button.primary,
        cursor: 'pointer',
        minWidth: 60,
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        touchAction: "manipulation",
        'white-space': 'nowrap',
        '&:active': {
            ...theme.palette.button.primary,
            border: 'none',
            outline: 'none'
        },
        '&:hover': {
            ...theme.palette.button.primary,
        },
        '&:focus': {
            ...theme.palette.button.primary,
            border: 'none',
            outline: 'none'
        }
    },
    filter_item_sub: {
        padding: theme.spacing(1, 3, 1, 3),
        margin: theme.spacing(1, 2, 1, 2),
        border: '1px solid',
        borderRadius: theme.shape.borderRadius5x,
        ...theme.palette.button.info,
        cursor: 'pointer',
        minWidth: 60,
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        touchAction: "manipulation",
        'white-space': 'nowrap',
        '&:active': {
            ...theme.palette.button.info,
            border: 'none',
            outline: 'none'
        },
        '&:hover': {
            ...theme.palette.button.info,
        },
        '&:focus': {
            ...theme.palette.button.info,
            border: 'none',
            outline: 'none'
        }
    },
    filter_item_sub_selected: {
        padding: theme.spacing(1, 3, 1, 3),
        margin: theme.spacing(1, 2, 1, 2),
        border: '1px solid',
        borderRadius: theme.shape.borderRadius5x,
        ...theme.palette.button.primary,
        cursor: 'pointer',
        minWidth: 60,
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        touchAction: "manipulation",
        'white-space': 'nowrap',
        '&:active': {
            ...theme.palette.button.primary,
            border: 'none',
            outline: 'none'
        },
        '&:hover': {
            ...theme.palette.button.primary,
        },
        '&:focus': {
            ...theme.palette.button.primary,
            border: 'none',
            outline: 'none'
        }
    },
})

function MenuItemsView(props) {
        const { classes, t, showLoading, open, onClose, order_type, menuItems, order_categories, sub_categories, delivery_fulfilled_by, totalQuantity, menuItemLength,
            pickupStoreAddress, deliveryAddress, categorySelected, subCategorySelected, carts, accept_change_fulfilled, currency, hasMore, handleLoadMore, showLoadMore
        } = props;
        const appConfig = getAppCfg()
        var ordering_model = appConfig.features && appConfig.features.business_network_details ? appConfig.features.business_network_details.ordering_model : null;
       // console.log("menuItems======:", menuItems);
       // console.log("menuItemLengthh:", menuItemLength);
        return (
            <DrawerCustom large open={open} onClose={onClose} fullScreen>
                <Grid xs={12} item className={classes.container}>
                    <Grid xs={12} item container direction='row'>
                        <Grid xs={11} item>
                        <Typo mg_top_sm variant='h5' color='onPrimary' className={classes.underline} onClick={ordering_model&&ordering_model==='MARKETPLACE' || order_type === 'PICK_UP' || order_type === 'DIRECT_SALE' ? props.onSelectMerchants : undefined}>
                            {order_type === 'PICK_UP' || order_type === 'DIRECT_SALE' ? pickupStoreAddress.name : (ordering_model && ordering_model=='MARKETPLACE' ?delivery_fulfilled_by.name:null)}
                        </Typo>
                            {/* <Typo variant='h3' color='onPrimary'>{order_type === 'DELIVERY' ? deliveryAddress.address_line_1 : ''}</Typo> */}
                        </Grid>
                        <Grid xs={1} item container justify='center' alignItems='center'>
                            {carts.length > 0 && <IconButton classes={{ root: classes.iconBtnRoot }} onClick={() => props.onEstimateOrder(null,null,null, true)}>
                                <Badge badgeContent={totalQuantity} color="primary" classes={{ colorPrimary: classes.badgeColorPrimary }}>
                                    <CartItemIcon />
                                </Badge>
                            </IconButton>}
                        </Grid>
                    </Grid>
                    <Grid xs={12} item className={classes.menu}>
                        <Grid xs={12} item className={classes.row}>
                            <Categories classes={classes} data={order_categories} selected={categorySelected} onSelect={props.onSelectCategory} />
                        </Grid>
                        <Grid xs={12} item className={classes.row}>
                            <SubCategories classes={classes} data={sub_categories} selected={subCategorySelected} onSelect={props.onSelectSubCategory} />
                        </Grid>
                        {showLoading && <CustomizedCircularProgress />}
                        <Grid xs={12} item className={classes.menu}>
                            <Grid xs={12} item container className={classes.menuContent}>
                                <Menu menu={menuItems} classes={classes} onClickItem={props.onClickItem} currency={currency} />
                            </Grid>
                            {menuItems.length > 0 && menuItemLength >= 100 && <Grid xs={12} item container justify='center' alignItems='center'>
                        <ButtonCustom color='onPrimary' round={false} size="sm" onClick={handleLoadMore}>{t('load_more')}
                                    {showLoadMore && <CircularProgress size={16} style={{ marginLeft: 12 }} />}
                                </ButtonCustom>
                            </Grid>}
                            {/* </InfiniteScroll> */}
                            {/* <Menu menu={menuItems} classes={classes} onClickItem={this.props.onClickItem} currency={currency} /> */}
                        </Grid>
                    </Grid>
                </Grid>
            </DrawerCustom>
        );
}
function Categories(props) {
    const { data, selected, classes } = props;
    //console.log('Categories =', data)
    // var component = data.map((cat, index) => {
    //     return (
    //         <ButtonCustom size="sm" key={cat.id}
    //             color={selected.id === cat.id ? 'category' : 'info'}
    //             onClick={() => props.onSelect(cat)}
    //         >
    //             {cat.name}
    //         </ButtonCustom>
    //     )
    // })
    // return component
    return (
        <div className="App">
            <ScrollMenu
            alignCenter={false}>
                {data.map((cat, index) =>
                    <div key={cat.id} onClick={() => props.onSelect(cat)} className={selected.id === cat.id ? classes.filter_item_selected : classes.filter_item}>
                        <Typo> {cat.display_name ? cat.display_name : cat.name}</Typo>
                    </div>
                )}
                </ScrollMenu>
         </div>
    )
}

function SubCategories(props) {
    const { data, selected, classes } = props;
    //console.log('SubCategories =', data)
    return (
         <div className="App">
            <ScrollMenu
                alignCenter={false}>
                                    {data.map((cat, index) =>
                    <div key={index} onClick={() => props.onSelect(cat)} className={selected && selected.id === cat.id ? classes.filter_item_sub_selected : classes.filter_item_sub}>
                        <Typo> {cat.display_name ? cat.display_name : cat.name}</Typo>
                    </div>
                )}
                    </ScrollMenu>
         </div>
    )
}

function Menu(props) {
    var menuItems = props.menu
    var menuComponent = menuItems.map((item, index) => {
        return (
            <Products products={item} classes={props.classes} onClickItem={props.onClickItem} currency={props.currency} />
        )
    })
    return menuComponent
}
function ProductImage(props) {
    if (props.image && props.image.url) {
        return <img className={props.classes.item_image} src={props.image.url} />
    } return <img className={props.classes.item_image_logo} src={getLogo()} />;
}
function Products(props) {
    var item = props.products;
    // console.log(' products===', products)
    // if(products&&products.length>=4){
    //     products[0].availability = 'DISABLED'
    //     products[4].availability = 'DISABLED'
    // }
    var classes = props.classes
    //var productComponent = products.map((item, index) => {
        return (
            <Grid xs={6} sm={6} md={4} key={item.id} item className={classNames(classes.itemContainer, item.availability==='DISABLED'?classes.item_disable:undefined) } onClick={item.availability==='DISABLED'?undefined:() => props.onClickItem(item)}>
                <Grid xs={12} item className={classes.itemContent}>
                    <Grid item container xs={12} className={classes.itemHeader} alignItems='center'>
                        <ProductImage classes={classes} image={dataUtil.getImageByUsageTypePortal(item.creatives, usage_type.product_item)} />
                    </Grid>
                    <Grid item container xs={12} className={classes.itemFooter} >
                        <Grid item container xs={12} alignItems='center'>
                            <Typo variant='subtitle1' color='primary' className={classes.wraptext}>{item.name}</Typo>
                        </Grid>
                        {/* {item.description && <Grid item xs={12} className={classes.itemDesc}>
                            <Typo variant='description' color='primary' className={classes.wraptext}>{item.description}</Typo>
                        </Grid>} */}
                        <Grid xs={12} item className={classes.itemPrice}>
                            <Typo mg_top_xs variant='subtitle1' color='primary'>{props.currency}{dataUtil.getProductPrice(item.pricing).toFixed(2)}</Typo>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    //})
    //return productComponent
}
export default withStyles(styles)(withTranslation()(MenuItemsView));